import React from 'react'
import { l } from '@manychat/manyui'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { FlowChartEmailContentBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

import { EmailContentMapping } from './components/EmailContentMapping'
import * as styles from './EmailContent.styles'

export const EmailContentBlock: BlockComponent<FlowChartEmailContentBlock> = ({ block }) => {
  return (
    <view style={styles.Wrapper}>
      <view style={styles.HeaderRow}>
        <richtext style={styles.Header} text={l.translate('Send from')} />
        <richtext style={styles.Text} text={block.data.sender} />
      </view>
      <view style={styles.HeaderRowWithSpacing}>
        <richtext style={styles.Header} text={l.translate('Subject')} />
        <richtext style={styles.Text} text={block.data.subject} />
      </view>
      <view style={styles.HeaderRowWithSpacing}>
        <richtext style={styles.Header} text={l.translate('Preheader')} />
        <richtext style={styles.Text} text={block.data.preheader} />
      </view>
      <view style={styles.HeaderRowWithSpacing}>
        <richtext style={styles.Header} text={l.translate('Structure')} />
      </view>
      {block.data.content.map((content) => {
        const Component = EmailContentMapping[content.type]
        if (!Component) {
          return null
        }

        return <Component key={content.id} content={content} />
      })}
    </view>
  )
}
